/**
 * Test Page for Transaction 2.0 and Task 2.0
 * Demonstrates the new clean implementation
 */

import { useState } from 'react';
import AddTransaction2 from '@/components/AddTransaction2';
import AddTask2 from '@/components/AddTask2';

export default function TestNewComponents() {
  const [activeTab, setActiveTab] = useState('transaction');

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">FinList 2.0 Test Page</h1>
        <p className="text-gray-600 mb-8">
          Clean, opinionated implementation on Firestore Cloud DB
        </p>

        {/* Tabs */}
        <div className="flex gap-4 mb-6 border-b">
          <button
            onClick={() => setActiveTab('transaction')}
            className={`pb-2 px-4 font-medium ${
              activeTab === 'transaction'
                ? 'border-b-2 border-black text-black'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Add Transaction
          </button>
          <button
            onClick={() => setActiveTab('task')}
            className={`pb-2 px-4 font-medium ${
              activeTab === 'task'
                ? 'border-b-2 border-black text-black'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Add Task
          </button>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          {activeTab === 'transaction' && (
            <div>
              <h2 className="text-xl font-semibold mb-4">Add Transaction 2.0</h2>
              <p className="text-sm text-gray-600 mb-6">
                ✅ Clean field names (description, notes)<br />
                ✅ Strict type validation (expense | income)<br />
                ✅ Always positive amounts<br />
                ✅ No undefined in Firestore
              </p>
              <AddTransaction2 
                onSuccess={(result) => {
                  console.log('Transaction created:', result);
                }}
              />
            </div>
          )}

          {activeTab === 'task' && (
            <div>
              <h2 className="text-xl font-semibold mb-4">Add Task 2.0</h2>
              <p className="text-sm text-gray-600 mb-6">
                ✅ Strict status validation (todo | in_progress | done | archived)<br />
                ✅ Optional financial context<br />
                ✅ Clean priority levels<br />
                ✅ No undefined in Firestore
              </p>
              <AddTask2 
                listId="default"
                onSuccess={(result) => {
                  console.log('Task created:', result);
                }}
              />
            </div>
          )}
        </div>

        {/* Guardrails */}
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="font-semibold mb-2">🛡️ FinList Guardrails Active</h3>
          <ul className="text-sm text-blue-900 space-y-1">
            <li>• User-scoped ownership enforced in Firestore rules</li>
            <li>• No side-effects on other modules (shopping, budgets)</li>
            <li>• No bank integration (user-entered data only)</li>
            <li>• Mandatory fields validated before Firestore write</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
